class plugins {
    setLocal(key, value) {
        window.localStorage.setItem(key, JSON.stringify(value))
    }
    getLocal(key) {
        const value = window.localStorage.getItem(key)
        if (value === "undefined") { return }
        if (value) {
            return JSON.parse(value)
        }
    }
    deleteLocal(key) {
        window.localStorage.removeItem(key)
    }
    setSession(key, value) {
        window.sessionStorage.setItem(key, JSON.stringify(value))
    }
    getSession(key) {
        const value = window.sessionStorage.getItem(key)
        if (value === "undefined") { return }
        if (value) {
            return JSON.parse(value)
        }
    }
    deleteSession(key) {
        window.sessionStorage.removeItem(key)
    }
    removeSellInfo() {
        window.localStorage.removeItem('itemDetails');
        window.localStorage.removeItem('itemDetailsIndex');
        window.localStorage.removeItem('ProofAuthenticity');
        window.localStorage.removeItem('sellDetail');
        window.localStorage.removeItem('sellPhotoUpload');
        window.localStorage.removeItem('sellFileUpload');
    }
    humanFormat(num, precision = 3) {
        /**
         * 将数字缩写为带单位的字符串：
         * - >= 1_000 显示为 K (千)
         * - >= 1_000_000 显示为 M (百万)
         * - >= 1_000_000_000 显示为 B (十亿)
         * - >= 1_000_000_000_000 显示为 T (万亿)
         * precision 控制小数位数
         */
        if (num === null || num === undefined) {
            return "0";
        }

        num = Number(num);
        const units = ["", "K", "M", "B", "T"];
        const k = 1000.0;
        let magnitude = 0;

        while (Math.abs(num) >= k && magnitude < units.length - 1) {
            magnitude += 1;
            num /= k;
        }

        return num.toFixed(precision) + units[magnitude];
    }
    formatPriceIntl(number, minimumFractionDigits = 2, locale = 'en-US') {
        const num = Number(number);

        if (isNaN(num)) {
            return String(number);
        }

        return new Intl.NumberFormat(locale, {
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: 20, // 允许最多 20 位小数，避免四舍五入
        }).format(num);
    }
}
export default new plugins
